export default {
  en: {
    'mcdelivery': 'McDelivery',
    'mcdelivery-analysis': 'McDelivery Analysis',
    'all-vendors': 'All Vendors',
    'deliveries': 'McDelivery',
    '3po-deliveries': 'McDelivery 3PO',
    'transactions': 'Transactions',
    'all-label': 'All',
    'vendors': 'Vendors',
    'delivery-vendors': 'Delivery Vendors',
    'sales-pct-change': 'Sales +/- %',
    'gc-pct-change': 'GC +/- %',
    'avg-check-pct-change': 'Avg Check +/- %',
    'combined-vendors': 'Combined Vendors',
    'four-days-ago': '4 Days Ago',
    'grubhub-warning': 'Grubhub 3PO order accuracy data is not currently available',
    'delivery-data-warning': 'Reports receive 3PO McDelivery data 3 days after the business date at 5:45 PM CST. First day available in reports is 4 days prior',
    'mcdelivery-3po': 'MCDelivery 3PO',
    'mcdelivery-3po-analysis': 'McDelivery 3PO Analysis',
    'vendor': 'Vendor',
    'delivery-transactions': 'Transactions',
    'total': 'Total',
    'by-date': 'By Date',
    'kiosk': 'Kiosk',
    'kiosk-cash': 'Kiosk Cash',
    'cash': 'Cash',
    'minutes-threshold': 'Minutes Threshold',
    'required': 'Required',
    'open-late-close-early': 'Open Late Close Early',
    'filter': 'Filter',
    'open-late-close-early-footer': 'This report uses the store settings from RFM and compares it against sales data to determine if the store may have opened late or closed early.',
    'open-late': 'Open Late',
    'close-early': 'Close Early',
    'sales-ledger-summary': 'Sales Ledger Summary',
    'sales-group': 'Sales Group',
    'sales-group-desc': 'Sales Groups are areas of the store (DT, Kiosk, etc) or Breakfast or Store Wide',
    'all-net-sales': 'All Net Sales',
    'all-net-sales-desc': 'Storewide All Net Sales',
    'all-net-sales-comp-amt': 'All Net Sales +/-',
    'all-net-sales-comp-amt-desc': 'All Net Sales compared to last year (trading or calendar day)',
    'all-net-sales-comp-pct': 'All Net Sales +/- %',
    'all-net-sales-comp-pct-desc': '',
    'gc': 'GC',
    'gc-comp-amt': 'GC +/-',
    'gc-comp-pct': 'GC +/- %',
    'gc-desc': 'Storewide Guest Count',
    'gc-comp-amt-desc': 'Guest Count compared to last year',
    'gc-comp-pct-desc': '',
    'avg-check': 'Average Check',
    'avg-check-desc': 'Storewide All Net Sales divided by Storewide GC',
    'avg-check-comp-amt': 'Average Check +/-',
    'avg-check-comp-amt-desc': 'Average Check compared to last year',
    'avg-check-comp-pct': 'Average Check +/- %',
    'avg-check-comp-pct-desc': 'Average Check increase or decrease percent compared to last year ((This Year minus Last Year) divided by Last Year)',
    'all-net-sales-pct': '% of All Net Sales',
    'all-net-sales-pct-desc': 'All Net Sales for the specific group divided by Store Wide All Net Sales',
    'sum-all-dates': 'Sum all Dates',
    'sales-point-of-order': 'Sales Point of Order',
    'store-wide': 'Store Wide',
    'drive-thru': 'Drive Thru',
    'front-counter': 'Front Counter',
    'mcd-delivery': 'McDelivery',
    'in-store': 'In Store',
    'mop': 'MOP',
    'where-served': 'Where Served',
    'store-hours': 'Store Hours',
    'store-hours-info': 'Store Hours are gathered from your RFM settings',
    'day-sales': 'Day Sales',
    '7-day': '7 Day',
    '14-day': '14 Day',
    '21-day': '21 Day',
    '28-day': '28 Day',
    'wtd': 'WTD',
    'mtd': 'MTD',
    'ytd': 'YTD',
    'month-to-date': 'Month To Date',
    'year-to-date': 'Year To Date',
    'sales-detail': 'Sales Detail',
    'sales-ledger': 'Sales Ledger',
    'sales-ledger-analysis': 'Sales Ledger Analysis',
    'closing-hour': 'Closing Hour',
    'closing-time': 'Closing Time',
    'closing-time-description': 'Closing hour set by Org',
    'lobby-latest-time': 'Lobby Latest Time',
    'lobby-latest-time-description': 'Destination of Eatin, TakeOut, Delivery, Kiosk and Mobile TakeOut latest time a transaction was recorded',
    'dt-latest-time': 'DT Latest Time',
    'dt-latest-time-description': 'Destination of DriveThru and Mobile Drive Thru latest time a transaction was recorded',
    'lobby-gap': 'Lobby Gap',
    'lobby-gap-description': 'Lobby Latest Time - Closing Time',
    'dt-gap': 'DT Gap',
    'dt-gap-description': 'DT Latest Time - Closing Time',
    'qbo-daily-sales': 'QBO Daily Sales',
    'journal-no': 'Journal No',
    'journal-date': 'Journal Date',
  },
  es: {
    'mcdelivery': 'McDelivery',
    'mcdelivery-analysis': 'Análisis de McDelivery',
    'all-vendors': 'Todos los Proveedores',
    'deliveries': 'McDelivery',
    '3po-deliveries': 'McDelivery 3PO',
    'transactions': 'Transacciones',
    'all-label': 'Todos',
    'vendors': 'Vendedores',
    'delivery-vendors': 'Vendedores de Entrega',
    'sales-pct-change': 'Ventas +/- %',
    'gc-pct-change': 'GC +/- %',
    'avg-check-pct-change': 'Cheque Prom +/- %',
    'combined-vendors': 'Proveedores Combinados',
    'four-days-ago': 'Hace 4 días',
    'grubhub-warning': 'Los datos de precisión de pedidos de Grubhub 3PO no están disponibles actualmente',
    'delivery-data-warning': 'Los informes reciben datos de 3PO McDelivery 3 días después de la fecha comercial a las 5:45 PM CST. El primer día disponible en los informes es 4 días antes',
    'mcdelivery-3po': 'MCDelivery 3PO',
    'mcdelivery-3po-analysis': 'Análisis de McDelivery 3PO',
    'vendor': 'Vendedor',
    'delivery-transactions': 'Transacciones',
    'total': 'Total',
    'by-date': 'Por Fecha',
    'kiosk': 'Kiosco',
    'kiosk-cash': 'Kiosco Efectivo',
    'cash': 'Efectivo',
    'minutes-threshold': 'Umbral de Minutos',
    'required': 'Requerido',
    'open-late-close-early': 'Apertura Tarde Cierre Temprano',
    'filter': 'Filtro',
    'open-late-close-early-footer': 'Este informe utiliza la configuración de la tienda de RFM y la compara con los datos de ventas para determinar si la tienda pudo haber abierto tarde o cerrado temprano.',
    'open-late': 'Apertura Tarde',
    'close-early': 'Cierre Temprano',
    'sales-ledger-summary': 'Resumen del Libro de Ventas',
    'sales-group': 'Grupo de Ventas',
    'sales-group-desc': 'Los grupos de ventas son áreas de la tienda (DT, Kiosco, etc.) o Desayuno o Tienda Completa',
    'all-net-sales': 'Ventas Netas Totales',
    'all-net-sales-desc': 'Ventas Netas Totales de Toda la Tienda',
    'all-net-sales-comp-amt': 'Ventas Netas Totales +/-',
    'all-net-sales-comp-amt-desc': 'Ventas Netas Totales comparadas con el año pasado (día comercial o calendario)',
    'all-net-sales-comp-pct': 'Ventas Netas Totales +/- %',
    'all-net-sales-comp-pct-desc': '',
    'gc': 'GC',
    'gc-comp-amt': 'GC +/-',
    'gc-comp-pct': 'GC +/- %',
    'gc-desc': 'Conteo Total de Clientes de la Tienda',
    'gc-comp-amt-desc': 'Conteo de Clientes comparado con el año pasado',
    'gc-comp-pct-desc': '',
    'avg-check': 'Ticket Promedio',
    'avg-check-desc': 'Ventas Netas Totales de la Tienda divididas por el Conteo Total de Clientes de la Tienda',
    'avg-check-comp-amt': 'Ticket Promedio +/-',
    'avg-check-comp-amt-desc': 'Ticket Promedio comparado con el año pasado',
    'avg-check-comp-pct': 'Ticket Promedio +/- %',
    'avg-check-comp-pct-desc': 'Porcentaje de aumento o disminución del Ticket Promedio comparado con el año pasado ((Este año menos el año pasado) dividido por el año pasado)',
    'all-net-sales-pct': '% de Ventas Netas Totales',
    'all-net-sales-pct-desc': 'Ventas Netas Totales para el grupo específico divididas por las Ventas Netas Totales de la Tienda',
    'sum-all-dates': 'Sumar Todas las Fechas',
    'sales-point-of-order': 'Punto de Venta',
    'store-wide': 'Todo el Local',
    'drive-thru': 'Auto Servicio',
    'front-counter': 'Mostrador',
    'mcd-delivery': 'McDelivery',
    'in-store': 'En Tienda',
    'mop': 'MOP',
    'where-served': 'Dónde se sirvió',
    'store-hours': 'Horas de la Tienda',
    'store-hours-info': 'Las horas de la tienda se recopilan de la configuración de RFM.',
    'day-sales': 'Ventas Diarias',
    '7-day': '7 Días',
    '14-day': '14 Días',
    '21-day': '21 Días',
    '28-day': '28 Días',
    'wtd': 'SDF',
    'mtd': 'MDF',
    'ytd': 'ADF',
    'month-to-date': 'Mes Hasta la Fecha',
    'year-to-date': 'Año Hasta la Fecha',
    'sales-detail': 'Detalle de Ventas',
    'sales-ledger': 'Libro de Ventas',
    'sales-ledger-analysis': 'Análisis del Libro de Ventas',
    'closing-hour': 'Hora de Cierre',
    'closing-time': 'Hora de Cierre',
    'closing-time-description': 'Hora de cierre establecida por la organización',
    'lobby-latest-time': 'Última Hora del Lobby',
    'lobby-latest-time-description': 'Hora más reciente de una transacción registrada en los destinos: Comer en Local, Para Llevar, Entrega, Kiosco y Para Llevar Móvil',
    'dt-latest-time': 'Última Hora de Auto',
    'dt-latest-time-description': 'Hora más reciente de una transacción registrada en los destinos: Auto Servicio y Auto Servicio Móvil',
    'lobby-gap': 'Diferencia del Lobby',
    'lobby-gap-description': 'Última Hora del Lobby - Hora de Cierre',
    'dt-gap': 'Diferencia de Auto',
    'dt-gap-description': 'Última Hora de Auto - Hora de Cierre',
    'qbo-daily-sales': 'Ventas Diarias QBO',
    'journal-no': 'Número de Diario',
    'journal-date': 'Fecha del Diario',
  },
};
